
export class Permission {
  id: number;
  name: string;
  moduleId?: number;
  icon?: string;

  deserialize(data: any): Permission {
    Object.assign(this, data);

    return this;
  }
}
